/* eslint-disable complexity */
/* eslint-disable no-restricted-imports */
import { ResponseProductAttribute } from '@/data/types/Product';
import { Stack, Typography } from '@mui/material';
import { FC } from 'react';
import { calculateOrderItemSummary, useRemoveItemCart } from '@/data/Content/Cart';
import { formatPrice } from '@/utils/formatPrice';
import { findProductAttribute } from 'integration/utils/findProductAttribute';
import { ProductImg } from '../../Cart/parts/OrderProductItem/parts/ProductImg';
import { Linkable } from '@/components/blocks/Linkable';
import { useIsMobile } from '@/data/hooks/useIsMobile';
import { OneClick } from '@/components/blocks/OneClick';
import TrashIcon from '@mui/icons-material/Delete';

export const HeaderMiniCartDropMenuItem: FC<{
	thumbnail: string;
	name: string;
	attributes: ResponseProductAttribute[];
	offerPrice: string | number;
	displayPrice: string | number;
	totalAdjustment: string | number;
	orderItemPrice: string | number;
	exhausted: boolean;
	variant?: 'mini' | 'drawer';
	href?: string;
	orderItemId: string;
	orderId: string;
}> = ({
	thumbnail,
	name,
	attributes,
	offerPrice,
	displayPrice,
	orderItemPrice,
	totalAdjustment,
	exhausted,
	variant = 'mini',
	href,
	orderItemId,
	orderId,
}) => {
	const size = findProductAttribute(attributes, 'Talla');

	const { shouldOffer, priceWithoutOffer, price } = calculateOrderItemSummary({
		offerPrice,
		displayPrice,
		orderItemPrice,
		totalAdjustment,
	});
	const isMobile = useIsMobile();
	const addElipsis = isMobile ? name.length > 30 : name.length > 18;

	const { removeOrderItem } = useRemoveItemCart();

	const handleOnRemove = async () => removeOrderItem(orderId, orderItemId);

	return (
		<Stack direction="row" spacing="12px">
			<ProductImg
				href={href}
				fullImageRaw={thumbnail}
				alt={name}
				expiration={exhausted}
				variant={variant}
			/>
			<Stack width="100%">
				<Linkable href={href}>
					<Typography
						sx={{
							fontSize: variant === 'mini' ? '14px' : '15px',
							fontWeight: 600,
							height: '20px',
							overflow: 'hidden',
						}}
					>
						{isMobile
							? addElipsis
								? `${name.slice(0, 29)}...`
								: name
							: addElipsis
							? `${name.slice(0, 17)}...`
							: name}
					</Typography>
				</Linkable>
				<Stack
					direction="row"
					spacing="20px"
					marginTop={{ xs: '4px', lg: '1px' }}
					marginBottom={{ xs: '0px', lg: '0px' }}
				>
					<Typography
						sx={{
							fontSize: variant === 'mini' ? '13px' : '15px',
							color: '#707070',
							display: 'flex',
							alignItems: 'center',
						}}
					>
						<Typography
							component="span"
							sx={{
								marginRight: '10px',
								fontSize: variant === 'mini' ? '13px' : '15px',
								fontWeight: variant === 'mini' ? 'normal' : 600,
								color: variant === 'mini' ? '#707070' : '#2C2C2C',
							}}
						>
							{'Talla: '}
						</Typography>
						{size?.value}
					</Typography>
					<Typography
						sx={{
							fontSize: variant === 'mini' ? '13px' : '15px',
							fontWeight: 'normal',
							color: '#707070',
						}}
					>
						<Typography
							component="span"
							sx={{
								marginRight: '10px',
								fontSize: variant === 'mini' ? '13px' : '15px',
								fontWeight: variant === 'mini' ? 'normal' : 600,
								color: variant === 'mini' ? '#707070' : '#2C2C2C',
							}}
						>
							{'Cantidad: '}
						</Typography>
						{1}
					</Typography>
				</Stack>
				<Stack direction="row" justifyContent="space-between" alignItems="center" width="100%">
					<Typography
						sx={{
							fontSize: variant === 'mini' ? '14px' : '15px',
							fontWeight: shouldOffer ? 400 : 600,
							color: !shouldOffer ? '#2C2C2C' : '#939393',
							textDecoration: shouldOffer ? 'line-through' : 'none',
						}}
					>
						{formatPrice('es-MX', 'MXN', priceWithoutOffer)}
					</Typography>
					{shouldOffer ? (
						<Typography
							sx={{
								color: shouldOffer ? '#B40309' : '#939393',
								fontSize: variant === 'mini' ? '14px' : '15px',
								marginLeft: '0.3rem',
								fontWeight: 600,
							}}
						>
							{formatPrice('es-MX', 'MXN', price)}
						</Typography>
					) : null}
					<OneClick wrapper="icon" onClick={handleOnRemove}>
						<TrashIcon sx={{ fontSize: variant === 'mini' ? '16px' : '20px' }} />
					</OneClick>
				</Stack>
			</Stack>
		</Stack>
	);
};
